import React, { Component } from 'react';

class Contact extends Component {
  render() {
    return (
      <div className="footer">
        <div className="app-content main-content">
            <div className="block__content">
            <div className="app-tri-grid">
              <div className="app-tri-grid__item">
              &copy;copyright EITX Consulting Ltd 2018
              </div>
              <div className="app-tri-grid__item social-links">
                <span className="social-link">
                  <a href="https://www.linkedin.com/company/eitx/" rel="noopener noreferrer" target="_blank" title="view our linkedin profile">
                    <i className="fa fa-linkedin fa-2" aria-hidden="true"></i>
                  </a>
                </span>
              </div>
              <div className="app-tri-grid__item align-right small-font">
                www.sheffieldwebsites.co.uk
              </div>
            </div>
            </div>
        </div>
      </div>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/shared/footer.js